var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecentlyViewed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.88,
    height: 58.88,
    viewBox: "0 0 58.88 58.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb63f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4513"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "recently_viewed",
    d: "M1148.856-498.391h-22.714a18.084,18.084,0,0,0-18.083,18.083v22.714a18.083,18.083,0,0,0,18.083,18.083h22.714a18.083,18.083,0,0,0,18.083-18.083v-22.714A18.084,18.084,0,0,0,1148.856-498.391Zm-11.357,48.66a19.242,19.242,0,0,1-19.22-19.22,19.242,19.242,0,0,1,19.22-19.22,19.165,19.165,0,0,1,12.09,4.3l4.077-4.077.466,5.893.466,5.894-5.894-.466-5.894-.466,4.618-4.617a16.128,16.128,0,0,0-9.928-3.419,16.193,16.193,0,0,0-16.175,16.175,16.192,16.192,0,0,0,16.175,16.175,16.193,16.193,0,0,0,16.175-16.175h3.045A19.242,19.242,0,0,1,1137.5-449.731Zm7.646-11.026-1.5,1.364-8.511-9.371,3.561-7.815,1.849.842-3.007,6.6Z",
    transform: "translate(-1108.059 498.391)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentlyViewed);
export default __webpack_public_path__ + "static/media/recentlyViewed.964319549637e83d409c3600c580918b.svg";
export { ForwardRef as ReactComponent };